<template>
    <div>
        <b-table
            show-empty
            :empty-text="emptyTextTable"
            ref="tableParcel" 
            responsive
            :selectable="(table.tabKey === 'PENDING') ? true : false"
            :items="shipmentPending"
            :fields="fields"
            @row-selected="onRowSelected"
            class="scroll-bar-pop"
            :busy="table.isLoading"
        >
            <div slot="table-busy" class="text-center">
                <div class="text-center text-primary my-2">
                    <i class="fas fa-circle-notch fa-spin"></i>
                    <strong> Loading...</strong>
                </div>
            </div>
            <template slot="HEAD_selected">
                <b-form-checkbox v-model="table.checkSelect" @change="selectAllRows()" class="text-center"></b-form-checkbox>
            </template>
            <template 
                slot="selected" 
                slot-scope="{ rowSelected }"
            >
                <template v-if="rowSelected">
                    <div class="custom-control custom-checkbox">
                        <input type="checkbox" autocomplete="off" class="custom-control-input" value="true" checked>
                        <label class="custom-control-label"></label>
                    </div>
                </template>
                    <template v-else>
                    <div class="custom-control custom-checkbox">
                        <input type="checkbox" autocomplete="off" class="custom-control-input" value="false">
                        <label class="custom-control-label"></label>
                    </div>
                </template>
            </template>
            <template slot="shipment_pending_category" slot-scope="row">
                <span class="text-newline">{{ (row.item.shipment_pending_category) ? row.item.shipment_pending_category.category_name : row.item.problem }}</span>
            </template>
            <!-- <template slot="image" slot-scope="row">
                <img class="mw-100 mh-100" src="/img/brand/logo.png" @click="showModalImages('img/brand/logo.png' , `รูประบบรอแจ้งปัญหา`)" />
            </template> -->
            <template slot="status_order" slot-scope="row">
                <b-badge :variant="statusInfo(row.item, {status: 'status_order'}).color +' report'" 
                    v-b-tooltip :title="statusInfo(row.item).tooltip">
                     {{statusInfo(row.item, {status: 'status_order'}).status}}
                </b-badge>
            </template>
            <template slot="remark" slot-scope="row">
                <textarea
                    rows="2"
                    class="form-control min-width-textarea"
                    v-model="row.item.remark"
                    :disabled="updateRemarkId != row.item.id"
                ></textarea>
            </template>
            <template slot="feedback" slot-scope="row">
                <span class="text-mute" v-if="!row.item.feedback_enable">รอขนส่งดำเนินการ</span>
                <textarea v-if="row.item.feedback_enable"
                    rows="2"
                    class="form-control min-width-textarea"
                    v-model="row.item.feedback"
                    :disabled="(table.tabKey === 'WAITING_FEEDBACK') ? !table.btnEdit : updateFeedbackId != row.item.id"
                ></textarea>
            </template>
            <template slot="date_time_complete" slot-scope="row">
                {{ (row.item.date_time_complete) ? row.item.date_time_complete : '-'}}
            </template>
            <template slot="manage" slot-scope="row">
                <template v-if="(table.tabKey === 'PENDING') ? updateRemarkId != row.item.id : updateFeedbackId != row.item.id">
                    <b-button 
                        size="sm" 
                        variant="primary" 
                        class="px-3" 
                        :disabled="table.isLoadingBtn"
                        @click="(table.tabKey === 'PENDING') ? updateRemarkId = row.item.id : updateFeedbackId = row.item.id"
                    >
                        แก้ไข
                    </b-button>
                    <b-button 
                        v-if="table.tabKey === 'PENDING'"
                        size="sm" 
                        variant="primary" 
                        class="px-3"
                        :disabled="table.isLoadingBtn"
                        @click="updateVisible(row.item.id) , sendVisibleId = row.item.id"
                    >
                        <i 
                            class="fas fa-circle-notch fa-spin" 
                            v-if="sendVisibleId == row.item.id">
                        </i> แจ้งลูกค้า
                    </b-button>
                </template>
                <template  v-else>
                    <b-button
                        size="sm" 
                        variant="success" 
                        class="px-3" 
                        :disabled="table.isLoadingBtn"
                        @click="(table.tabKey === 'PENDING') ? editRemarkParcel(row.item) : updateFeedback(row.item)"
                    >
                        <i class="fas fa-circle-notch fa-spin" v-if="table.isLoadingBtn && ( updateRemarkId == row.item.id || updateFeedbackId == row.item.id )"></i> บันทึก
                    </b-button>
                    <b-button
                        size="sm" 
                        variant="default" 
                        class="px-3" 
                        :disabled="table.isLoadingBtn"
                        @click="updateRemarkId = null , updateFeedbackId = null"
                    >
                        ยกเลิก
                    </b-button>
                </template>
                
            </template>
        </b-table>
        <ModalImagesLightBox ref="imageLightBox" :imagesLightBox="dataImagesLightBox" />
    </div>
</template>

<script>
import ModalImagesLightBox from '@/components/Modals/ModalImagesLightBox'
import { statusParcel } from "@/plugins/formatReportParcel.js";
import { updateRemarkShipmentPending , updateVisibleShipmentPending , updateFeedbackShipmentPending } from "@/axios/failReport.js";
import { showSuccessModal , showErrorModal } from "@/components/modalNotification.js";
import { statusInfo } from "@/plugins/statusCourier.js"

export default {
    props:{
        table: Object,
        reportParcel: Object
    },
    components:{
        ModalImagesLightBox
    },
    data(){
        return{
            updateRemarkId: null,
            updateFeedbackId: null,
            sendStatusCourierId: null,
            sendVisibleId:null,
            statusInfo: statusInfo,
            dataImagesLightBox:{
                show:false,
                image:false,
            },
        }
    },
    methods: {
        onRowSelected(items) {
            let listSelectedParcel = []
           
            items.forEach((items, index) => {
                listSelectedParcel.push(items.id)
            })

            this.table.selectedParcel = listSelectedParcel
        },
        selectAllRows() {
            this.table.checkSelect = !this.table.checkSelect
            if(this.table.checkSelect){
                this.$refs.tableParcel.selectAllRows()
            }else{
                this.$refs.tableParcel.clearSelected()
            }
        },
        showModalImages( img , name ){
           this.dataImagesLightBox.show = true
           this.dataImagesLightBox.image = [ { src:'img/brand/logo.png',name:'name:1' },{ src:'img/brand/logo.png', name:'name:2'}]
        },
        async editRemarkParcel( shipment ){
            this.table.isLoadingBtn = true;
            await updateRemarkShipmentPending( shipment.id , shipment.remark ).then( res => {
                showSuccessModal('อัพเดท Remark สำเร็จแล้ว');
                this.updateRemarkId = null
                this.table.isLoadingBtn = false;
            }).catch(error => {
                showErrorModal('ไม่สามารถอัพเดท Remark ได้ ' + error);
                this.table.isLoadingBtn = false;
            });
        },
        async updateVisible( shipment_id ){
            this.table.isLoadingBtn = true;
            if( !Array.isArray(shipment_id) ){
                shipment_id = [shipment_id]
            }
            await updateVisibleShipmentPending( shipment_id , 'show' ).then( res => {
                showSuccessModal('แจ้งลูกค้าสำเร็จแล้ว');
                this.sendVisibleId = null
                this.$emit('getReportShipmentPending');
            }).catch(error => {
                showErrorModal('ไม่สามารถแจ้งลูกค้าได้ ' + error);
                this.sendVisibleId = null
                this.table.isLoadingBtn = false;
            });
        },
        async updateFeedback( shipment ){
            this.table.isLoadingBtn = true
            let shipmentUpdate = [];
            if(shipment){
                shipmentUpdate = [{ id: shipment.id , feedback: shipment.feedback }]
            }else{
                shipmentUpdate = this.feedbackUpdateAll;
            }
           
            await updateFeedbackShipmentPending( shipmentUpdate ).then( res => {
                showSuccessModal('อัพเดท Feedback สำเร็จแล้ว');
                this.updateFeedbackId = null
                this.table.btnEdit = false;
                this.$emit('getReportShipmentPending');
            }).catch(error => {
                showErrorModal('ไม่สามารถอัพเดท Feedback ได้ ' + error);
                this.table.isLoadingBtn = false;
            });
        },
        // async updateStatusCourier( shipment_id ){
        //     if( !Array.isArray(shipment_id) ){
        //         shipment_id = [shipment_id]
        //     }
        //     await updateStatusCourierShipmentPending( shipment_id , 1 ).then( res => {
        //         showSuccessModal('แจ้งขนส่งสำเร็จแล้ว');
        //         this.sendStatusCourierId = null
        //         this.$emit('getReportShipmentPending');
        //     }).catch(error => {
        //         showErrorModal('ไม่สามารถแจ้งขนส่งได้ ' + error);
        //         this.sendStatusCourierId = null
        //     });
        // }
    }, 
    computed: {
        fields(){ 
            let fields = [
                ...( ['PENDING'].includes(this.table.tabKey) ) ? [{ key: "selected", label: "เลือกรายการ", class: "text-center" }] : [],
                { key: "courier_tracking_code", label: "หมายเลขพัสดุ", sortable: true },
                ...( ['RESOLVED'].includes(this.table.tabKey) ) ? [{ key: "status_order", label: "สถานะพัสดุ", sortable: true }] : [],
                ...( this.$USER_LOGIN.get().isSuperadmin ) ? [{ key: "shop_code", label: "รหัสร้านค้า", sortable: true }] : [],
                { key: "shipment_pending_category", label: "ประเภทปัญหา", sortable: true },
                { key: "sender_name", label: "ข้อมูลต้นทาง", sortable: true },
                { key: "dest_name", label: "ข้อมูลปลายทาง", sortable: true },
                { key: "remark", label: "Remark" },
                // { key: "images", label: "รูปภาพ" },
                ...( ['WAITING_FEEDBACK','REPLIED','RESOLVED'].includes(this.table.tabKey) ) ? [{ key: "feedback", label: "Feedback" }] : [],
                { key: "date_time_pending", label: "เวลาที่แจ้งปัญหา", sortable: true },
                ...( ['REPLIED'].includes(this.table.tabKey) ) ? [{ key: "date_time_pending", label: "เวลาที่ลูกค้าตอบกลับ", sortable: true }] : [],
                ...( ['RESOLVED'].includes(this.table.tabKey) ) ? [{ key: "date_time_complete", label: "เวลาที่ปัญหาเสร็จสิ้น", class: "text-center" }] : [],
                ...( ['PENDING','REPLIED'].includes(this.table.tabKey) ) ? [{ key: "manage", label: "การจัดการ", class: "text-center" }] : [], 
            ]
            return fields
        },
        feedbackUpdateAll(){
            let shipmentUpdate = [];
            this.feedbackShipment.forEach( shipment => {
                shipmentUpdate.push({
                    id: shipment.id , 
                    feedback: shipment.feedback
                }) 
            })
            return shipmentUpdate;
        },
        feedbackShipment(){
            return this.shipmentPending.filter( shipment => shipment.feedback )
        },
        shipmentPending(){
            return this.reportParcel.items.filter( shipment => shipment.status == this.table.tabKey )
        },
        emptyTextTable(){
            return statusParcel[this.table.tabKey].empty
        },
    },
}
</script>